import React, { SVGProps } from "react";

export default function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" {...props}>
      <rect
        x="10.9497"
        y="-0.36377"
        width="2"
        height="16"
        rx="1"
        transform="rotate(45 10.9497 -0.36377)"
        fill={props.fill}
      />
      <rect
        x="1.05029"
        y="-0.36377"
        width="16"
        height="2"
        rx="1"
        transform="rotate(45 1.05029 -0.36377)"
        fill={props.fill}
      />
    </svg>
  );
}
